/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { PostUsersForgotPasswordMutationRequest, PostUsersForgotPasswordMutationResponse, PostUsersForgotPassword400 } from "../entities/PostUsersForgotPassword";

function getPostUsersForgotPasswordUrl() {
  const res = { method: 'POST', url: `/users/forgot-password` as const }  
  return res
}

/**
 * @description Восстановление пароля
 * @summary Восстановление пароля
 * {@link /users/forgot-password}
 */
export async function postUsersForgotPassword(data: PostUsersForgotPasswordMutationRequest, config: Partial<RequestConfig<PostUsersForgotPasswordMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<PostUsersForgotPasswordMutationResponse, ResponseErrorConfig<PostUsersForgotPassword400>, PostUsersForgotPasswordMutationRequest>({ method : "POST", url : getPostUsersForgotPasswordUrl().url.toString(), data : requestData, ... requestConfig })  
  return res.data
}